// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rJ__","textarea":"styles_textarea__3jc6-"};